const getTermsConditionsText = function(companyName) {
  return "<p>I HEREBY AGREE AS FOLLOWS:</p> <ol><li>By applying for a personal loan with Financing Partner, I read, understood and willing to obtain a personal loan on the terms and conditions of the Financing Partner documents, subject to my eligibility criteria and fulfilling necessary documentation process with Financing Partner.</li><li> I accept the terms and conditions and request Financing Partner to disburse the personal loan amount to me on the said terms.</li> <li>I hereby, declare that, the entries made by me in the Application Form are complete and true to the best of my knowledge and based on records. </li><li>I, hereby, undertake to present the original documents immediately upon demand by the concerned authorities of the Financing Partner.</li><li> I, hereby undertake to inform the Financing Partner & Company/my current employer, about any changes in information submitted by me, in the Application Form and any other documents, including change in addresses and phone nos., from time to time. </li><li>I, hereby authorise, explicitly consent to Company to validate and provide the information sought by the Financing Partner regarding my employment and payroll including salary & deductions related details.</li><li> I also expressly agree and undertake to repay my loan outstanding through EMI mode, as specified in the loan agreement. i.e., the subsequent EMIs (along with interest payments, including revised interest rates / delayed charges, if applicable) henceforth. </li><li>I further given my consent and hereby authorize " + companyName + " and/or any of its group companies, where I am employed as on date (“Current Employer”) to deduct the EMI amount as specified by me from my monthly salary payout, which will be paid to the Financing Partner by " + companyName + " and/or any of its group companies, till the time I am employed with the Current Employer or loan closure confirmation from me to the Current Employer, whichever is earlier, subject to applicable deductions and policies from time to time.</li><li> I agree that personal loan repayment or EMI payment is always my responsibility and liability to repay all outstanding amounts to the Financing Partner on or within the stipulated dates, and " + companyName + " and/or any of its group companies is not be made responsible / liable for any outstanding dues or any non-payment or any other charges payable by me to the Financing Partner, in case there is a delay or default in my loan repayment at any point of time. </li><li>I further declare and undertake, that if at any stage, my employment with Company can be terminated /comes to an end, and loan will be refunded by me to Financing Partner directly.</li><li> I hereby agree to buy Acko Group Health Insurance Policy and provide my express consent to the terms and conditions. </li><li>I hereby declare that I am in good health and do not suffer from any Pre-Existing medical conditions or critical illness covered under the policy.</li><li> I am consenting to share my data including aadhar details with NBFC partner - Avanti Finance. </li><li>I agree that my family income is greater than 3 lakhs</li><li>I give my consent  to share the KYC received via Hyperverge with the Lender for the processing of the loan.</li></ol>"
}

const full_name_config = {
  label: "Full Name/पूरा नाम:",
  type: "text",
  name: "name",
  id: "name",
  validation: {
    required: {
      value: true,
      message: "required",
    },
  },
  page: "personal-details",
};
const company_config = {
  label: "Company Name",
  type: "text",
  name: "customer_name",
  id: "customer_name",
  validation: {
    required: {
      value: true,
      message: "required",
    },
  },
  page: "company-details",
};

const email_config = {
  label: "Email Id/ईमेल आईडी",
  type: "text",
  name: "email",
  id: "email",
  validation: {
    required: {
      value: false,
      message: "optional",
    },
  },
  page: "personal-details",
};

const fathers_name_config = {
  label: "Fathers Name/पिताजी का नाम:",
  type: "text",
  name: "fathers_name",
  id: "fathers_name",
  validation: {
    required: {
      value: true,
      message: "required",
    },
  },
  page: "personal-details",
};

const perm_address_config = {
  label: "Permanent Address/स्थायी पता:",
  type: "text",
  name: "perm_address",
  id: "perm_address",
  validation: {
    required: {
      value: true,
      message: "required",
    },
  },
  page: "personal-details",
};

const curr_address_config = {
  label: "Current Address/वर्त्तमान पता",
  type: "text",
  name: "curr_address",
  id: "curr_address",
  validation: {
    required: {
      value: true,
      message: "required",
    },
  },
  page: "personal-details",
};

const dob_config = {
  label: "What is your Date of Birth (DoB)?/जन्म की तारीख",
  type: "date",
  name: "date_of_birth",
  id: "date_of_birth",
  validation: {
    required: {
      value: true,
      message: "required",
    },
  },
  page: "personal-details",
};

const loan_amount_config = {
  label: "Loan Amount(In Rupees)/लोन रकम(रुपये में):",
  type: "number",
  name: "loan_amount",
  id: "loan_amount",
  validation: {
    required: {
      value: true,
      message: "required",
    },
    min: 0,
  },
  page: "loan-details",
  inputInfoText: "Please note we can only provide loans up to loan_amount",
};
const purpose_config = {
  label: "Purpose of loan / ऋण का उद्देश्य",
  type: "text",
  name: "purpose",
  id: "purpose",
  defaultValue: "", // Added default value
  validation: {
    required: {
      value: false,
      message: "optional",
    },
  },
  page: "loan-details",
};
const deposit_amount_config = {
  label: "Deposit Amount(In Rupees)/जमा राशि (रुपये में)):",
  type: "number",
  name: "deposit_amount",
  id: "deposit_amount",
  validation: {
    required: {
      value: true,
      message: "required",
    },
    min: 0,
  },
  page: "personal-details",
  inputInfoText: "Please mention the deposit required",
};
const loan_duration_config = {
  label: "Loan Duration(in Months)/लोन अवधि(महीनों में):",
  type: "number",
  name: "loan_period",
  id: "loan_period",
  validation: {
    required: {
      value: true,
      message: "required",
    },
    min: 0,
    max: 10,
  },
  page: "loan-details",
  inputInfoText: "Limit of tenure is 10 months only",
};
const terms_conditions_config = {
  label: "",
  type: "textarea",
  name: "terms_conditions",
  id: "terms_conditions",
  validation: {
    required: {
      value: true,
      message: "required",
    },
  },
  page: "terms-details",
};
const gender_config = {
  label: "Gender/लिंगि:",
  type: "select",
  name: "gender",
  id: "gender",
  validation: {
    required: {
      value: true,
      message: "required",
    },
  },
  placeholder: "Please select a gender",
  options: [
    { value: "Male", label: "Male" },
    { value: "Female", label: "Female" },
  ],
  page: "personal-details",
};

const repayment_config = {
  label: "loan repayment frequency/ऋण चुकौती आवृत्ति:",
  type: "select",
  name: "repayment_frequency",
  id: "repayment_frequency",
  validation: {
    required: {
      value: true,
      message: "required",
    },
  },
  placeholder: "Please select your preferred repayment frequency",
  options: [
    { value: "Weekly", label: "Weekly" },
    { value: "Monthly", label: "Monthly" },
  ],
  page: "loan-details",
};

const marital_status_config = {
  label: "Marital Status/वैवाहिक स्थिति:",
  type: "select",
  name: "marital_status",
  id: "marital_status",
  validation: {
    required: {
      value: true,
      message: "required",
    },
  },
  placeholder: "Please select a marital status",
  options: [
    { value: "Single", label: "Single" },
    { value: "Married", label: "Married" },
    { value: "Divorced", label: "Divorced" },
  ],
  page: "personal-details",
};
const pan_card_config = {
  label: "PAN Card Number/पैन कार्ड नंबर:",
  type: "text",
  name: "pan_card",
  id: "pan_card",
  validation: {
    required: {
      value: true,
      message: "required",
    },
    pattern: /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/,
  },
  page: "personal-details",
};
const company_name_config = {
  label: "Company Name where you are working currently / कंपनी का नाम जहाँ आप अभी काम कर रहे है ",
  type: "text",
  name: "customer_name",
  id: "customer_name",
  validation: {
    required: {
      value: true,
      message: "required",
    },
  },
  placeholder: "Please select a company name",
  // options: [],
  page: "company-details",
};
const date_of_joining_config = {
  label: "Date of Joining of current company / वर्तमान कंपनी जॉइन करने के तारीख",
  type: "date",
  name: "date_of_joining",
  id: "date_of_joining",
  validation: {
    required: {
      value: true,
      message: "required",
    },
  },
  page: "company-details",
};
const salary_inhand_config = {
  label: "Total Salary /  कुल वेतन",
  type: "number",
  name: "salary_inhand",
  id: "salary_inhand",
  validation: {
    required: {
      value: true,
      message: "required",
    },
    min: 0,
  },
  page: "company-details",
  inputInfoText:"(Note: If your salary is monthly, specify salary amount that you receive in one month. If your salary is weekly, specify salary amount that you receive in one week)"
};
const city_config = {
  label: "City name where you are working curently/ शहर का नाम जहां आप अभी काम कर रहे है।",
  type: "text",
  name: "work_location",
  id: "work_location",
  validation: {
    required: {
      value: true,
      message: "required",
    },
  },
  page: "company-details",
};
const salary_freq_config = {
  label: "Salary Frequency / वेतन मिलने का समय",
  type: "select",
  name: "salary_frequency",
  id: "salary_frequency",
  validation: {
    required: {
      value: true,
      message: "required",
    },
  },
  placeholder: "Salary Frequency / वेतन मिलने का समय",
  options: [
    { value: "Weekly", label: "Weekly" },
    { value: "Monthly", label: "Monthly" },
  ],
  page: "company-details",
};
const salary_day_config = {
  label: "Salary day  / वेतन मिलने का दिन ",
  type: "text",
  name: "salary_day",
  id: "salary_day",
  validation: {
    required: {
      value: true,
      message: "required",
    },
    // min: 1,
    // max:31,
  },
  page: "company-details",
  inputInfoText: "(Note: If your salary is monthly, specify date of salary. If your salary is weekly, specify day of salary like Monday/Tuesday etc / अगर आपका वेतन मासिक है, तो वेतन आने की तारीख बताएं। अगर आपका वेतन साप्ताहिक है, तो वेतन आने का दिन बताएं जैसे सोमवार, मंगलवार आदि।)",
};
const designation_config = {
  label: "Designation/ उपाधि",
  type: "text",
  name: "designation",
  id: "designation",
  validation: {
    required: {
      value: true,
      message: "required",
    },
  },
  page: "company-details",
};
const company_employee_id_config = {
  label: "Employee Id/ कर्मचारी ID",
  type: "text",
  name: "company_employee_id",
  id: "company_employee_id",
  validation: {
    required: {
      value: true,
      message: "required",
    },
  },
  page: "personal-details",
};
const bank_account_no_config = {
  label: "Bank Account No./ बैंक खाता क्रमांक",
  type: "text",
  name: "account_no",
  id: "account_no",
  validation: {
    required: {
      value: true,
      message: "required",
    },
  },
  page: "personal-details",
};

const perm_address_pincode_config = {
  label: "Permanent Pincode/ स्थायी पिनकोड",
  type: "text",
  name: "perm_address_pincode",
  id: "perm_address_pincode",
  validation: {
    required: {
      value: true,
      message: "required",
    },
  },
  page: "personal-details",
};

const curr_address_pincode_config = {
  label: "Current Pincode/ वर्तमान पिनकोड",
  type: "text",
  name: "curr_address_pincode",
  id: "curr_address_pincode",
  validation: {
    required: {
      value: true,
      message: "required",
    },
  },
  page: "personal-details",
};
const ifsc_config = {
  label: "IFSC Code/ आईएफएससी कोड(भारतीय वित्तीय प्रणाली कोड)",
  type: "text",
  name: "ifsc_code",
  id: "ifsc_code",
  validation: {
    required: {
      value: true,
      message: "required",
    },
    pattern: {
      value: /^[A-Za-z]{4}[a-zA-Z0-9]{7}$/,
      message: "Invalid IFSC code format"
    }
  },
  page: "personal-details",
};
const mobile_number_config = {
  label: "Enter mobile number",
  type: "number",
  name: "mobile_number",
  id: "mobile_number",
  validation: {
    required: {
      value: true,
      message: "Mobile number is required",
    },
    maxLength: {
      value: 10,
      message: "Mobile number should be 10 digit",
    },
    minLength: {
      value: 10,
      message: "Mobile number should be 10 digit",
    },
  },
  page: "personal-details",
  inputInfoText:
    "After submission, we will be sending status updates on your whatsapp number",
};

const adhaar_card_config = {
  label: "Aadhaar Card Number/आधार कार्ड नंबर:",
  type: "text",
  name: "aadhaar",
  id: "aadhaar",
  validation: {
    required: {
      value: true,
      message: "required",
    },
    pattern: /^\d{12}$/,
  },
  page: "personal-details",
};

export const formFields = {
  quess: [
    full_name_config,
    email_config,
    salary_inhand_config,
    date_of_joining_config,
    dob_config,
    {
      ...loan_amount_config,
      validation: {
        ...loan_amount_config.validation,
        max: 50000,
      },
      inputInfoText: loan_amount_config.inputInfoText.replace(
        "loan_amount",
        "50,000"
      ),
    },
    loan_duration_config,
    purpose_config,
    {
      ...terms_conditions_config,
      text: getTermsConditionsText("Quess Corp Ltd"),
    },
  ],
  swiggy: [
    full_name_config,
    email_config,
    {
      ...company_employee_id_config,
      label: "Swiggy DE ID number/स्विगी आईडी नंबर:",
    },
    dob_config,
    pan_card_config,
    {
      ...loan_amount_config,
      validation: {
        ...loan_amount_config.validation,
        max: 50000,
      },
      inputInfoText: loan_amount_config.inputInfoText.replace(
        "loan_amount",
        "50,000"
      ),
    },
    loan_duration_config,
    gender_config,
    marital_status_config,
    {
      ...terms_conditions_config,
      text: getTermsConditionsText("Swiggy"),
    },
  ],
  entitled: [
    full_name_config,
    email_config,
    dob_config,
    pan_card_config,
    {
      ...loan_amount_config,
      validation: {
        ...loan_amount_config.validation,
        max: 50000,
      },
      inputInfoText: loan_amount_config.inputInfoText.replace(
        "loan_amount",
        "50,000"
      ),
    },
    loan_duration_config,
    gender_config,
    marital_status_config,
    {
      ...company_name_config,
      options: [
        { value: "WIFY", label: "WIFY" },
        { value: "Pecopp", label: "Pecopp" },
        { value: "Viridian", label: "Viridian" },
        { value: "Care24", label: "Care24" },
        { value: "XYXX", label: "XYXX" },
        { value: "Others", label: "Others" },
      ],
    },
    {
      ...company_employee_id_config,
      label: "Employee Id Number",
    },
    city_config,
    {
      ...terms_conditions_config,
      text: "<p>I HEREBY AGREE AS FOLLOWS:</p> <ol><li> I have been engaged with the “Company” as a full-time or contractual “Employee” or as an independent service provider as a “Gig Worker”.</li> <li> The “Company” has tied up with “Entitled Solutions Pvt Ltd” (hereinafter referred to as “Entitled”) to enable access to a “Loan Program”.</li> <li> “Entitled” is a benefits solution that enables access to loans (besides other services) for workers. It works with RBI registered NBFCs to process such loans for workers.</li> <li>I hereby confirm that I am willing to participate in the ‘Loan Program’ being provided by “Entitled”.</li><li> For the aforesaid purpose, I authorise the “Company” to deduct the instalments payable by me to “Entitled” for availing the loan facility provided by “Entitled”, from my pay-outs and remit the same to “Entitled” on my behalf.</li><li>I also authorise “Entitled” to charge instalments payable by me to “Entitled” for availing the loan facility provided by “Entitled”, to my bank account to which the “Company” deposits the salary or payout on a monthly or weekly basis via eNACH.</li><li> In addition to the same, I authorize the “Company” to share my personal information with “Entitled” including but not limited to my name, phone number, address, date of engagement with the “Company”, my status (active/inactive), bank account details, my gross earnings etc</li><li>I understand and agree that the “Company” will not be responsible / liable in any manner for any issues, claims, losses or damages arising in relation to the loan availed by me.</li><li> I understand and agree that the “Company” will not be responsible / liable in any manner for any issues, claims, losses or damages arising in relation to deductions from my payouts.</li>  <li> I hereby agree to buy Acko Group Health Insurance Policy and provide my express consent to the terms and conditions. </li> <li> I hereby declare that I am in good health and do not suffer from any Pre-Existing medical conditions or critical illness covered under the policy. </li> </ol>",
    },
  ],
  letstransport: [
    full_name_config,
    email_config,
    dob_config,
    pan_card_config,
    {
      ...loan_amount_config,
      validation: {
        ...loan_amount_config.validation,
        max: 100000,
      },
      inputInfoText: loan_amount_config.inputInfoText.replace(
        "loan_amount",
        "1,00,000"
      ),
    },
    loan_duration_config,
    {
      ...terms_conditions_config,
      text: getTermsConditionsText("LetsTransport"),
    },
  ],
  MarapurandJamindarguriTeaEstate: [
    full_name_config,
    email_config,
    pan_card_config,
    {
      ...loan_amount_config,
      validation: {
        ...loan_amount_config.validation,
        max: 50000,
      },
      inputInfoText: loan_amount_config.inputInfoText.replace(
        "loan_amount",
        "50,000"
      ),
    },
    loan_duration_config,
    {
      ...terms_conditions_config,
      text: getTermsConditionsText("Marapur and Jamindarguri Tea Estate"),
    },
  ],
  enableCap: [
    full_name_config,
    email_config,
    dob_config,
    pan_card_config,
    {
      ...loan_amount_config,
      validation: {
        ...loan_amount_config.validation,
        max: 100000,
      },
      inputInfoText: loan_amount_config.inputInfoText.replace(
        "loan_amount",
        "1,00,000"
      ),
    },
    loan_duration_config,
    gender_config,
    marital_status_config,
    {
      ...company_name_config,
      options: [
        {
          value: "The Maintenance Wallas",
          label: "The Maintenance Wallas",
        },
        {
          value: "Kolkata Response Group Pvt Ltd",
          label: "Kolkata Response Group Pvt Ltd",
        },
      ],
    },
    {
      ...terms_conditions_config,
      text: getTermsConditionsText("EnableCap"),
    },
  ],
  mobiGarage: [
    full_name_config,
    email_config,
    pan_card_config,
    {
      ...loan_amount_config,
      validation: {
        ...loan_amount_config.validation,
        max: 100000,
      },
      inputInfoText: loan_amount_config.inputInfoText.replace(
        "loan_amount",
        "1,00,000"
      ),
    },
    loan_duration_config,
    {
      ...terms_conditions_config,
      text: getTermsConditionsText("mobiGarage"),
    },
  ],
  pecopp: [
    full_name_config,
    email_config,
    {
      ...company_employee_id_config,
      label: "Pecopp ID number/पकप्प आईडी नंबर:",
    },
    dob_config,
    pan_card_config,
    {
      ...loan_amount_config,
      validation: {
        ...loan_amount_config.validation,
        max: 50000,
      },
      inputInfoText: loan_amount_config.inputInfoText.replace(
        "loan_amount",
        "50,000"
      ),
    },
    loan_duration_config,
    gender_config,
    marital_status_config,
    {
      ...terms_conditions_config,
      text: getTermsConditionsText("Pecopp"),
    },
  ],
  wify: [
    full_name_config,
    email_config,
    {
      ...company_employee_id_config,
      label: "Wify Employee ID /Wify कर्मचारी आईडी",
    },
    dob_config,
    pan_card_config,
    {
      ...loan_amount_config,
      validation: {
        ...loan_amount_config.validation,
        max: 50000,
      },
      inputInfoText: loan_amount_config.inputInfoText.replace(
        "loan_amount",
        "50,000"
      ),
    },
    loan_duration_config,
    gender_config,
    marital_status_config,
    {
      ...terms_conditions_config,
      text: getTermsConditionsText("Wify"),
    },
  ],
  myMobiForce: [
    full_name_config,
    email_config,
    {
      ...company_employee_id_config,
      label: "MyMobiforce  ID number/पकप्प आईडी नंबर:",
    },
    dob_config,
    pan_card_config,
    {
      ...loan_amount_config,
      validation: {
        ...loan_amount_config.validation,
        max: 50000,
      },
      inputInfoText: loan_amount_config.inputInfoText.replace(
        "loan_amount",
        "50,000"
      ),
    },
    loan_duration_config,
    gender_config,
    marital_status_config,
    {
      ...terms_conditions_config,
      text: getTermsConditionsText("myMobiForce"),
    },
  ],
  zypp: [
    full_name_config,
    email_config,
    dob_config,
    {
      ...loan_amount_config,
      validation: {
        ...loan_amount_config.validation,
        max: 50000,
      },
      inputInfoText: loan_amount_config.inputInfoText.replace(
        "loan_amount",
        "50,000"
      ),
    },
    loan_duration_config,
    {
      ...terms_conditions_config,
      text: getTermsConditionsText("Zypp"),
    },
  ],
  smartstaff: [
    full_name_config,
    email_config,
    {
      ...company_employee_id_config,
      label: "SmartStaff ID number/आईडी नंबर:",
    },
    dob_config,
    {
      ...loan_amount_config,
      validation: {
        ...loan_amount_config.validation,
        max: 50000,
      },
      inputInfoText: loan_amount_config.inputInfoText.replace(
        "loan_amount",
        "50,000"
      ),
    },
    loan_duration_config,
    {
      ...terms_conditions_config,
      text: getTermsConditionsText("SmartStaff"),
    },
  ],
  b2c: [
    full_name_config,
    email_config,
    pan_card_config,
    dob_config,
    gender_config,
    marital_status_config,
    company_name_config,
    designation_config,
    date_of_joining_config,
    city_config,
    salary_freq_config,
    salary_day_config,
    salary_inhand_config,
    loan_amount_config,
    loan_duration_config,
    
    {
      ...terms_conditions_config,
      text: getTermsConditionsText("Company"),
    },
  ],
  chefkart: [
    full_name_config,
    email_config,
    dob_config,
    pan_card_config,
    {
      ...loan_amount_config,
      validation: {
        ...loan_amount_config.validation,
        max: 50000,
      },
      inputInfoText: loan_amount_config.inputInfoText.replace(
        "loan_amount",
        "50,000"
      ),
    },
    loan_duration_config,
    {
      ...terms_conditions_config,
      text: getTermsConditionsText("Chefkart"),
    },
  ],
  EverestFleet: [
    full_name_config,
    email_config,
    {
      ...company_employee_id_config,
      label: "Everest Fleet ID number/आईडी नंबर:",
    },
    dob_config,
    gender_config,
    pan_card_config,
    {
      ...loan_amount_config,
      validation: {
        ...loan_amount_config.validation,
        max: 100000,
      },
      inputInfoText: loan_amount_config.inputInfoText.replace(
        "loan_amount",
        "1,00,000"
      ),
    },
    {
      ...loan_duration_config,
      validation: {
        ...loan_duration_config.validation,
        max: 12,
      },
      inputInfoText: "Limit of tenure is 12 months only"
    },
    {
      ...terms_conditions_config,
      text: getTermsConditionsText("EverestFleet"),
    },
  ],
  intrcity: [
    full_name_config,
    email_config,
    dob_config,
    pan_card_config,
    {
      ...loan_amount_config,
      validation: {
        ...loan_amount_config.validation,
        max: 50000,
      },
      inputInfoText: loan_amount_config.inputInfoText.replace(
        "loan_amount",
        "50,000"
      ),
    },
    loan_duration_config,
    gender_config,
    marital_status_config,
    date_of_joining_config,
    designation_config,
    bank_account_no_config,
    ifsc_config,
    {
      ...terms_conditions_config,
      text: getTermsConditionsText("Intrcity"),
    },
  ],
  rydo: [
    email_config,
    full_name_config,
    dob_config,
    pan_card_config,
    {
      ...loan_amount_config,
      validation: {
        ...loan_amount_config.validation,
        max: 50000,
      },
      inputInfoText: loan_amount_config.inputInfoText.replace(
        "loan_amount",
        "50,000"
      ),
    },
    loan_duration_config,
    gender_config,
    marital_status_config,
    {
      ...terms_conditions_config,
      text: getTermsConditionsText("Rydo"),
    },
  ],
  sis: [
    full_name_config,
    email_config,
    dob_config,
    pan_card_config,
    {
      ...loan_amount_config,
      validation: {
        ...loan_amount_config.validation,
        max: 50000,
      },
      inputInfoText: loan_amount_config.inputInfoText.replace(
        "loan_amount",
        "50,000"
      ),
    },
    loan_duration_config,
    purpose_config,
    gender_config,
    marital_status_config,
    {
      ...terms_conditions_config,
      text: "<p>I HEREBY AGREE AS FOLLOWS:</p> <ol><li>By applying for a personal loan with Financing Partner, I read, understood and willing to obtain a personal loan on the terms and conditions of the Financing Partner documents, subject to my eligibility criteria and fulfilling necessary documentation process with Financing Partner.</li><li> I accept the terms and conditions and request Financing Partner to disburse the personal loan amount to me on the said terms.</li> <li>I hereby, declare that, the entries made by me in the Application Form are complete and true to the best of my knowledge and based on records. </li><li>I, hereby, undertake to present the original documents immediately upon demand by the concerned authorities of the Financing Partner.</li><li> I, hereby undertake to inform the Financing Partner & Company/my current employer, about any changes in information submitted by me, in the Application Form and any other documents, including change in addresses and phone nos., from time to time. </li><li>I, hereby authorise, explicitly consent to Company to validate and provide the information sought by the Financing Partner regarding my employment and payroll including salary & deductions related details.</li><li> I also expressly agree and undertake to repay my loan outstanding through EMI mode, as specified in the loan agreement. i.e., the subsequent EMIs (along with interest payments, including revised interest rates / delayed charges, if applicable) henceforth. </li><li>I further given my consent and hereby authorize SIS Group Enterprises and/or any of its group companies, where I am employed as on date (“Current Employer”) to deduct the EMI amount as specified by me from my monthly salary payout, which will be paid to the Financing Partner by SIS Group Enterprises and/or any of its group companies, till the time I am employed with the Current Employer or loan closure confirmation from me to the Current Employer, whichever is earlier, subject to applicable deductions and policies from time to time.</li><li> I agree that personal loan repayment or EMI payment is always my responsibility and liability to repay all outstanding amounts to the Financing Partner on or within the stipulated dates, and SIS Group Enterprises and/or any of its group companies is not be made responsible / liable for any outstanding dues or any non-payment or any other charges payable by me to the Financing Partner, in case there is a delay or default in my loan repayment at any point of time. </li><li>I further declare and undertake, that if at any stage, my employment with Company can be terminated /comes to an end, and loan will be refunded by me to Financing Partner directly.</li><li> I hereby agree to buy Acko Group Health Insurance Policy and provide my express consent to the terms and conditions. </li><li>I hereby declare that I am in good health and do not suffer from any Pre-Existing medical conditions or critical illness covered under the policy.</li><li> I am consenting to share my data including aadhar details with NBFC partner - Avanti Finance. </li><li>I agree that my family income is greater than 3 lakhs</li><li>I give my consent  to share the KYC received via Hyperverge with the Lender for the processing of the loan.</li></ol>",
    },
  ],
  logipe: [
    full_name_config,
    email_config,
    dob_config,
    pan_card_config,
    {
      ...loan_amount_config,
      validation: {
        ...loan_amount_config.validation,
        max: 50000,
      },
      inputInfoText: loan_amount_config.inputInfoText.replace(
        "loan_amount",
        "50,000"
      ),
    },
    loan_duration_config,
    gender_config,
    marital_status_config,
    {
      ...terms_conditions_config,
      text: getTermsConditionsText("Logipe"),
    },
  ],
  chaloNetwork: [
    mobile_number_config,
    email_config,
    full_name_config,
    {
      ...company_employee_id_config,
      label: "Chalo Network ID number/आईडी नंबर:",
    },
    dob_config,
    gender_config,
    pan_card_config,
    {
      ...loan_amount_config,
      validation: {
        ...loan_amount_config.validation,
        max: 100000,
      },
      inputInfoText: loan_amount_config.inputInfoText.replace(
        "loan_amount",
        "1,00,000"
      ),
    },
    {
      ...loan_duration_config,
      validation: {
        ...loan_duration_config.validation,
        max: 12,
      },
      inputInfoText: "Limit of tenure is 12 months only"
    },
    {
      ...terms_conditions_config,
      text: getTermsConditionsText("ChaloNetwork"),
    },
  ],
  moove: [
    mobile_number_config,
    email_config,
    full_name_config,
    fathers_name_config,
    // {
    //   ...company_employee_id_config,
    //   label: "Moove ID number/आईडी नंबर:",
    // },
    {
      ...dob_config,
      label: "Date of Birth as per pan card/जन्मतिथि पैन कार्ड के अनुसार:",
    },
    gender_config,
    pan_card_config,
    adhaar_card_config,
    marital_status_config,
    // date_of_joining_config,
    perm_address_config,
    perm_address_pincode_config,
    curr_address_config,
    curr_address_pincode_config,
    {
      ...loan_amount_config,
      validation: {
        ...loan_amount_config.validation,
        max: 35000,
      },
      inputInfoText: loan_amount_config.inputInfoText.replace(
        "loan_amount",
        "35,000"
      ),
    },
    {
      ...deposit_amount_config,
      validation: {
        ...deposit_amount_config.validation,
        max: 35000,
      }
    },
    {
      ...loan_duration_config,
      validation: {
        ...loan_duration_config.validation,
        max: 6,
      },
      inputInfoText: "Limit of tenure is 6 months only"
    },
    repayment_config,
    {
      ...terms_conditions_config,
      text: "<p>I HEREBY AGREE AS FOLLOWS:</p> <ol><li> I have been engaged with the “Company” as a full-time or contractual “Employee” or as an independent service provider as a “Gig Worker”.</li> <li> The “Company” has tied up with “Entitled Solutions Pvt Ltd” (hereinafter referred to as “Entitled”) to enable access to a “Loan Program”.</li> <li> “Entitled” is a benefits solution that enables access to loans (besides other services) for workers. It works with RBI registered NBFCs to process such loans for workers.</li> <li>I hereby confirm that I am willing to participate in the ‘Loan Program’ being provided by “Entitled”.</li><li> For the aforesaid purpose, I authorise the “Company” to deduct the instalments payable by me to “Entitled” for availing the loan facility provided by “Entitled”, from my pay-outs and remit the same to “Entitled” on my behalf.</li><li>I also authorise “Entitled” to charge instalments payable by me to “Entitled” for availing the loan facility provided by “Entitled”, to my bank account to which the “Company” deposits the salary or payout on a monthly or weekly basis via eNACH.</li><li> In addition to the same, I authorize the “Company” to share my personal information with “Entitled” including but not limited to my name, phone number, address, date of engagement with the “Company”, my status (active/inactive), bank account details, my gross earnings etc</li><li>I understand and agree that the “Company” will not be responsible / liable in any manner for any issues, claims, losses or damages arising in relation to the loan availed by me.</li><li> I understand and agree that the “Company” will not be responsible / liable in any manner for any issues, claims, losses or damages arising in relation to deductions from my payouts.</li>  <li> I hereby agree to buy Acko Group Health Insurance Policy and provide my express consent to the terms and conditions. </li> <li> I hereby declare that I am in good health and do not suffer from any Pre-Existing medical conditions or critical illness covered under the policy. </li> </ol>",
    },
  ],
};
